import dhtmlx from '../../global/dhtmlx';
import  {__extends} from './eXcell';
import goingValidation from '../../global/goingValidationClass';
import eXcell_edn from './eXcell_edn';


function _getFontClickEvent(clickEvent, gridObj) {
    if (goingValidation.isNotNull(clickEvent)) {
        var eventName = "click_" + dhtmlx.uid;
        window[eventName] = function (elObj) {
            var val = $(elObj).attr("cellvalue");
            var rowid = $(elObj).attr("rowid");
            clickEvent(val, rowid, gridObj.vueObj, gridObj);
        };
        return "onclick='" + eventName + "(this)'";
    }
}
var eXcell_fontIcon = (function (_super) {
    __extends(eXcell_fontIcon, _super);
    function eXcell_fontIcon(cell) {
        _super.call(this, cell);
    }
    eXcell_fontIcon.prototype.setValue = function (val) {
        var iconFun = this.grid.fontIconAry[this.cell._cellIndex];
        var rowId = this.cell.parentNode.idd;
        var _grid$fontIconItemAry = this.grid.fontIconItemAry[this.cell._cellIndex], _grid$fontIconItemAry2 = _grid$fontIconItemAry.showLabel, showLabel = _grid$fontIconItemAry2 === undefined ? true : _grid$fontIconItemAry2, clickEvent = _grid$fontIconItemAry.clickEvent;
        if (iconFun != null) {
            var ionClass = iconFun(val, rowId, this.grid);
            if (goingValidation.isNotEmpty(ionClass)) {
                if (showLabel) {
                    //如果需要显示label
                    this.cell.innerHTML = this.grid._aplNF('<div cellvalue="' +
                        val +
                        '" rowid="' +
                        rowId +
                        '" class="fontIcon_cell padding-r-bs" ' +
                        _getFontClickEvent(clickEvent, this.grid) +
                        ' style="cursor: pointer;">\n                  <i style=\'position:relative;top:-2px;\'  class="' +
                        ionClass +
                        '"></i><span>' +
                        val +
                        "</span></div>", this.cell._cellIndex);
                }
                else {
                    //如果不需要显示label
                    this.cell.innerHTML = this.grid._aplNF('<div cellvalue="' +
                        val +
                        '" rowid="' +
                        rowId +
                        '" ' +
                        _getFontClickEvent(clickEvent, this.grid) +
                        ' class="fontIcon_cell padding-r-bs" style="cursor: pointer;">\n                  <i style=\'position:relative;top:-2px;cursor: pointer;\' class="' +
                        ionClass +
                        '"></i></div>', this.cell._cellIndex);
                }
            }
        }
    };
    eXcell_fontIcon.prototype.getValue = function () {
        return this.cell.innerText;
    };
    eXcell_fontIcon.prototype.isDisabled = function () {
        return true;
    };
    eXcell_fontIcon.prototype.edit = function () {
        return false;
    };
    return eXcell_fontIcon;
})(eXcell_edn);
window.eXcell_fontIcon = eXcell_fontIcon;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_fontIcon.js